module.exports = __webpack_public_path__ + "img/logo-ufms.9c88bedd.png";